document.addEventListener("DOMContentLoaded", function () {
	// Function to update the pseudo-element width
	function updatePseudoElementWidth(patternContainer) {
		const ukContainer = patternContainer.querySelector(".uk-container");

		if (ukContainer && patternContainer) {
			const ukContainerOffset = ukContainer.getBoundingClientRect().left;
			let ukContainerPadding = 36;
			if (window.innerWidth <= 768) {
				ukContainerPadding = parseFloat(getComputedStyle(ukContainer).paddingLeft) || 33;
			}
			const adjustedWidth = ukContainerOffset + ukContainerPadding;

			patternContainer.style.setProperty("--pseudo-width", `${adjustedWidth}px`);
		}
	}

	function applySvgFit(patternContainer) {
		const svg = patternContainer.querySelector(".heroLottieContainer svg");
		if (!svg) return;
		if (window.innerWidth <= 768) {
			svg.setAttribute("preserveAspectRatio", "xMinYMid slice");
		} else {
			svg.setAttribute("preserveAspectRatio", "xMidYMid meet");
		}
	}

	// Function to animate the pseudo-element
	function triggerPseudoElementAnimation(patternContainer) {
		if (patternContainer) {
			// Clear any existing timeouts for this specific patternContainer
			if (patternContainer._animationTimeouts) {
				patternContainer._animationTimeouts.forEach(clearTimeout);
			}
			patternContainer._animationTimeouts = [];

			// Reset classes and force reflow
			patternContainer.classList.remove("animate-expand", "animate-retract");
			void patternContainer.offsetWidth; // Force reflow

			updatePseudoElementWidth(patternContainer);
			patternContainer.classList.add("animate-expand");

			const timeout1 = setTimeout(() => {
				patternContainer.classList.remove("animate-expand");
				patternContainer.classList.add("animate-retract");

				const timeout2 = setTimeout(() => {
					patternContainer.classList.remove("animate-retract");
				}, 1500); // Duration of retract animation
				patternContainer._animationTimeouts.push(timeout2);
			}, 4500); // Time before retract starts
			patternContainer._animationTimeouts.push(timeout1);
		}
	}

	// Function to load, configure, and play Lottie for static hero blocks
	function loadAndPlayStaticLottie(container, patternContainerForLoop) {
		if (!container) return;

		// Clear previous animation if any
		if (container.lottieInstance) {
			container.lottieInstance.destroy();
			container.lottieInstance = null;
		}
		while (container.firstChild) {
			container.removeChild(container.firstChild);
		}

		const animationPath = container.dataset.animationPath;
		if (animationPath) {
			const animation = window.lottie.loadAnimation({
				container: container,
				renderer: "svg",
				loop: true,
				autoplay: false,
				path: animationPath,
			});
			container.lottieInstance = animation;

			animation.addEventListener("DOMLoaded", () => {
				if (patternContainerForLoop) {
					applySvgFit(patternContainerForLoop);
				}
				animation.play();
				if (patternContainerForLoop) {
					animation.removeEventListener("loopComplete");
					animation.addEventListener("loopComplete", () => {
						triggerPseudoElementAnimation(patternContainerForLoop);
					});
				}
			});
		}
	}

	// Function to set up animations for static hero blocks
	function setupStaticHeroAnimations() {
		const staticHeroElements = document.querySelectorAll(".heroBlock2025__wrapper");

		staticHeroElements.forEach((staticHero) => {
			const lottieContainer = staticHero.querySelector(".heroLottieContainer");
			const patternContainer = staticHero.querySelector(".heroBlock2025__animatedPattern");

			// Lottie animation for static hero (will also trigger pattern animation on loop)
			if (lottieContainer) {
				loadAndPlayStaticLottie(lottieContainer, patternContainer);
			}

			if (patternContainer) {
				triggerPseudoElementAnimation(patternContainer);
			}
		});
	}

	// Initialize static hero animations (does not depend on Swiper)
	setupStaticHeroAnimations();
	window.addEventListener("resize", () => {
		const patternContainers = document.querySelectorAll(".heroBlock2025__animatedPattern");
		patternContainers.forEach((patternContainer) => {
			updatePseudoElementWidth(patternContainer);
			applySvgFit(patternContainer);
		});
	});
});
